import {
  regularValidationZip,
  regularValidationStateCode,
  regularValidationDefaultAddress,
} from '@utils';

import { BillingAddressParams } from '@modules/user/types';

import { CHECK_STATE_COUNTRIES } from './constants';

export const isValid = (
  value: string | undefined,
  regex = regularValidationDefaultAddress
): boolean => {
  return regex.test(value || '');
};

export default function validateBillingAddress(
  data?: Record<string, string | undefined> | undefined | null,
  checkState?: boolean
): data is BillingAddressParams {
  if (!data) return false;
  const { country_code, state_code, street_line_1, street_line_2, city, zip_code } = data;

  const isCountryValid = isValid(country_code);
  const isStateValid =
    checkState === false ||
    !CHECK_STATE_COUNTRIES.some(c => c === country_code?.toLowerCase()) ||
    isValid(state_code, regularValidationStateCode);

  const isStreet1Valid = (!street_line_1 && !!street_line_2) || isValid(street_line_1);
  const isStreet2Valid = (!street_line_2 && !!street_line_1) || isValid(street_line_2);
  const isStreetValid = isStreet2Valid && isStreet1Valid;

  const isCityValid = isValid(city);
  const isZipValid = isValid(zip_code, regularValidationZip);

  return isCountryValid && isStateValid && isStreetValid && isCityValid && isZipValid;
}
